import * as types from 'actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  showTools: false,
  toolsLoading: false,
};

const general = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SHOW_TOOLS:
      return dotProp.set(state, 'showTools', action.value);
    case types.TOOLS_LOADING:
      return dotProp.set(state, 'toolsLoading', action.value);
    default:
      return state;
  }
};

export default general;
